module.exports = __webpack_public_path__ + "af3d923534de03e2b9ea5b5eae8435a8.png";